"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyAgreement = applyAgreement;
var _view = require("../view");
var _view2 = require("../../types/view");
var _tracking = require("../../utils/tracking");
var _authentication = require("../authentication");
var _phoneAuth = require("../phoneAuth");
var _social = require("../social");
var _flow = require("../flow");
var _flow2 = require("../../types/flow");
function applyAgreement() {
  return (dispatch, getState, context) => {
    const {
      logger
    } = context;
    const {
      view,
      source
    } = getState();
    const viewData = view.data;
    switch (viewData.prevView) {
      case _view2.EActiveView.AuthenticationRegistration:
        dispatch((0, _flow.changeFlow)(_flow2.EActiveFlow.Registration));
        dispatch((0, _authentication.changePassword)(''));
        dispatch((0, _view.previousView)());
        (0, _tracking.trackShowTwoStepPasswordRegistration)(source);
        break;
      case _view2.EActiveView.PhoneAuth:
        dispatch((0, _phoneAuth.sendCode)());
        break;
      case _view2.EActiveView.AccountSelect:
        dispatch((0, _phoneAuth.registerOrAuthorizeByToken)());
        break;
      case _view2.EActiveView.SocialCreate:
        dispatch((0, _view.previousView)());
        dispatch((0, _social.create)());
        break;
      default:
        logger.warning(`Invalid previous view "${viewData.prevView}" on applyAgreement step`);
    }
  };
}